import React, {memo} from 'react';
import {ControlModel, InputModel, MediaModel} from '../../types/control';
import {Control} from './control';
import {ScenarioModel} from '../../store/control/state';
import {Scenario} from './scenario';
import {Sensor} from './sensor';
import {Media} from '../Controls/AirConditionerControl';

export type ItemListProps = {
    controls?: ControlModel[];
    scenarios?: ScenarioModel[];
    sensors?: InputModel[];
    medias?: MediaModel[];
};

export const ItemList = memo(function ItemList({controls, scenarios, sensors, medias}: ItemListProps) {
    return (
        <>
            {
                renderIf(medias)(() =>
                    medias.map(media => (
                        <Media
                            key={`media_${media.id}`}
                            media={media}/>
                    )),
                )
            }
            {
                renderIf(controls)(() =>
                    controls.map(control => (
                        <Control
                            key={`control_${control.id}`}
                            control={control}/>
                    )),
                )
            }
            {
                renderIf(scenarios)(() =>
                    scenarios.map(scenario => (
                        <Scenario
                            key={`scenario_${scenario.id}`}
                            scenario={scenario}/>
                    )),
                )
            }
            {
                renderIf(sensors)(() =>
                    sensors.map(sensor => (
                        <Sensor
                            key={`sensor_${sensor.id}`}
                            sensor={sensor}/>
                    )),
                )
            }
        </>
    );
});
